import { render, staticRenderFns } from "./waitDetailDialog.vue?vue&type=template&id=e831e5d0&scoped=true"
import script from "./waitDetailDialog.vue?vue&type=script&lang=js"
export * from "./waitDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./waitDetailDialog.vue?vue&type=style&index=0&id=e831e5d0&prod&lang=less"
import style1 from "./waitDetailDialog.vue?vue&type=style&index=1&id=e831e5d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e831e5d0",
  null
  
)

export default component.exports